import moment from "moment";
import { User } from "src/app/core/models/auth.models";
import { ProjectRequestModel } from "../../project-request/models/project-request.model";
import { ProjectModel } from "./project.model";

export enum MeetingType {
  PRESENCIAL = 'PRESENCIAL',
  ONLINE = 'ONLINE',
  NONE = 'NONE',
}

export class EventModel {
  public id: number;

  public initialDate: Date;
  public finalDate: Date;

  public title: string;
  public description: string;
  public meetingType: MeetingType;

  public local: string | null;
  public videoRoomName: string | null;
  public videoUrl: string | null;
  public url: string | null;

  public uploadedFiles: any[];
  public receiverUsers: any[] | null;
  public receiverTeams: any[] | null;

  public typeId: number | null;
  public sprintId: number | null;
  public projectRequestId: number | null;
  public projectId: number | null;
  public authorId: number | null;

  public type: any | null;
  public sprint: any | null;
  public projectRequest: ProjectRequestModel | null;
  public project: ProjectModel | null;
  public author: User | null;

  public createdAt: Date;
  public updatedAt: Date;

  public isRepeat: number | null;
  public repeatMON: number | null;
  public repeatTUE: number | null;
  public repeatWED: number | null;
  public repeatTHU: number | null;
  public repeatFRI: number | null;
  public repeatSAT: number | null;
  public repeatSUN: number | null;
  public repeatTimeStart: number | null;
  public repeatTimeStop: number | null;
  public repeatCycle: number | null;

  constructor($obj?: any) {
    this.id = $obj ? $obj.id : '#new' + moment().valueOf();

    this.initialDate = $obj && $obj.initialDate ? new Date($obj.initialDate) : new Date();
    this.finalDate = $obj && $obj.finalDate ? new Date($obj.finalDate) : new Date();

    this.title = $obj && $obj.title ? $obj.title : '';
    this.description = $obj && $obj.description ? $obj.description : '';
    this.meetingType = $obj && $obj.meetingType ? $obj.meetingType : MeetingType.NONE;

    this.local = $obj && $obj.local ? $obj.local : null;
    this.videoRoomName = $obj && $obj.videoRoomName ? $obj.videoRoomName : null;
    this.videoUrl = $obj && $obj.videoUrl ? $obj.videoUrl : null;
    this.url = $obj && $obj.url ? $obj.url : null;

    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];
    this.receiverUsers = $obj && $obj.receiverUsers ? $obj.receiverUsers : [];
    this.receiverTeams = $obj && $obj.receiverTeams ? $obj.receiverTeams : [];

    this.typeId = $obj && $obj.typeId ? $obj.typeId : $obj && $obj.type ? $obj.type.id : null;
    this.sprintId = $obj && $obj.sprintId ? $obj.sprintId : $obj && $obj.sprint ? $obj.sprint.id : null;
    this.projectRequestId = $obj && $obj.projectRequestId ? $obj.projectRequestId : $obj && $obj.projectRequest ? $obj.projectRequest.id : null;
    this.projectId = $obj && $obj.projectId ? $obj.projectId : $obj && $obj.project ? $obj.project.id : null;
    this.authorId = $obj && $obj.authorId ? $obj.authorId : $obj && $obj.author ? $obj.author.id : null;

    this.type = $obj && $obj.type ? $obj.type : null;
    this.sprint = $obj && $obj.sprint ? $obj.sprint : null;
    this.projectRequest = $obj && $obj.projectRequest ? new ProjectRequestModel($obj.projectRequest) : null;
    this.project = $obj && $obj.project ? new ProjectModel($obj.project) : null;
    this.author = $obj && $obj.author ? new User($obj.author) : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();

    this.isRepeat = $obj && $obj.isRepeat ? $obj.isRepeat : null;    
    this.repeatMON = $obj && $obj.repeatMON ? $obj.repeatMON : null;    
    this.repeatTUE = $obj && $obj.repeatTUE ? $obj.repeatTUE : null;    
    this.repeatWED = $obj && $obj.repeatWED ? $obj.repeatWED : null;    
    this.repeatTHU = $obj && $obj.repeatTHU ? $obj.repeatTHU : null;    
    this.repeatFRI = $obj && $obj.repeatFRI ? $obj.repeatFRI : null;    
    this.repeatSAT = $obj && $obj.repeatSAT ? $obj.repeatSAT : null;    
    this.repeatSUN = $obj && $obj.repeatSUN ? $obj.repeatSUN : null;    
    this.repeatTimeStart = $obj && $obj.repeatTimeStart ? $obj.repeatTimeStart : null;    
    this.repeatTimeStop = $obj && $obj.repeatTimeStop ? $obj.repeatTimeStop : null;    
    this.repeatCycle = $obj && $obj.repeatCycle ? $obj.repeatCycle : null;    

  }

  setByForm(form: any) {
    this.initialDate = new Date(form.initialDate);
    this.finalDate = new Date(form.finalDate);
    this.title = form.title;
    this.description = form.description;
    this.meetingType = form.meetingType;
    this.local = form.local;
    this.url = form.url;
    if (form.typeId) this.typeId = form.typeId;
    if (form.sprintId) this.sprintId = form.sprintId;
    this.receiverUsers = form.users ? form.users : [];
    this.receiverTeams = form.teams ? form.teams : [];
    this.uploadedFiles = form.uploadedFiles;

    this.isRepeat = form.isRepeat;
    this.repeatMON = form.repeatMON;
    this.repeatTUE = form.repeatTUE;
    this.repeatWED = form.repeatWED;
    this.repeatTHU = form.repeatTHU;
    this.repeatFRI = form.repeatFRI;
    this.repeatSAT = form.repeatSAT;
    this.repeatSUN = form.repeatSUN;
    this.repeatTimeStart = form.repeatTimeStart;
    this.repeatTimeStop = form.repeatTimeStop;
    this.repeatCycle = form.repeatCycle;

    return this;
  }

  toAPI() {
    return {
      initialDate: this.initialDate,
      finalDate: this.finalDate,
      title: this.title,
      description: this.description,
      meetingType: this.meetingType,
      local: this.local,
      url: this.url,
      receiverUsers: this.receiverUsers,
      receiverTeams: this.receiverTeams,
      typeId: this.typeId,
      sprintId: this.sprintId,
      projectRequestId: this.projectRequestId,
      projectId: this.projectId,
      authorId: this.authorId,
      isRepeat : this.isRepeat,
      repeatMON : this.repeatMON,
      repeatTUE : this.repeatTUE,
      repeatWED : this.repeatWED,
      repeatTHU : this.repeatTHU,
      repeatFRI : this.repeatFRI,
      repeatSAT : this.repeatSAT,
      repeatSUN : this.repeatSUN,
      repeatTimeStart : this.repeatTimeStart,
      repeatTimeStop : this.repeatTimeStop,
      repeatCycle : this.repeatCycle
    };
  }

}
